import { nameInitials } from "components/Scorecard/components/scorecardItem/nameInitials";
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import { getUserDataOnce } from "services/firebase";
import { useTeeTimes } from "hooks/useTeeTimes";
import ArrowLeft from "assets/arrowLeft.svg";
import { useEffect, useState } from "react";
import Text from "components/Common/Text";
import { useAuth } from "hooks/useAuth";
import Sheet from "react-modal-sheet";
import Venmo from "assets/venmo.svg";
import PropTypes from "prop-types";
import "./styles.css";
import { useUserData } from "hooks/useUserData";
// eslint-disable-next-line import/no-cycle
import Tip from "./tip";

import { VenmoForm } from "./venmoForm";

function PayoutValue({ amount }) {
  let sign = "";

  if (amount > 0) {
    sign = "+";
  } else if (amount < 0) {
    sign = "-";
  }

  let className = "tee-time-player-payout--total-value";

  if (amount > 0) {
    className += " tee-time-player-payout--total-positive";
  } else if (amount < 0) {
    className += " tee-time-player-payout--total-negative";
  }

  return (
    <div className={className}>{`${sign}$${Math.abs(amount).toFixed(0)}`}</div>
  );
}

PayoutValue.propTypes = {
  amount: PropTypes.number,
};

PayoutValue.defaultProps = {
  amount: 0,
};

// eslint-disable-next-line no-unused-vars, react/prop-types
export function VenmoButton({ venmoAccount, amount, plus, openModal }) {
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      href={
        plus
          ? null
          : `https://venmo.com/?txn=pay&audience=private&recipients=${venmoAccount}&amount=${Math.abs(
              amount,
            )}&note=PINZ%20settle%20up`
      }
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => plus && openModal()}
      style={{
        backgroundColor: "#008CFF",
        height: 38,
        width: 74,
        display: "flex",
        placeItems: "center",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 8,
        marginLeft: 8,
        flexDirection: "row",
      }}
    >
      {plus && (
        <Text style={{ lineHeight: 10 }} as="H2">
          +
        </Text>
      )}
      <img src={Venmo} alt="venmo" />
    </a>
  );
}

function ListItem({
  displayName,
  courseHandicap,
  amount,
  venmoAccount,
  showPayout,
}) {
  return (
    <div
      className="tee-time-player-payout--list-item-wrapper"
      key={displayName}
    >
      <div>
        <div className="tee-time-player-payout--list-item-name">
          {nameInitials(displayName)}
        </div>
        <div className="tee-time-player-payout--list-item-handicap">
          {`HDCP ${courseHandicap}`}
        </div>
      </div>

      <div
        style={{
          flexDirection: "row",
          display: "flex",
          alignItems: "center",
        }}
      >
        <PayoutValue amount={amount} />
        {venmoAccount && showPayout && amount < 0 && (
          <VenmoButton venmoAccount={venmoAccount} amount={amount} />
        )}
      </div>
    </div>
  );
}

ListItem.propTypes = {
  displayName: PropTypes.string.isRequired,
  courseHandicap: PropTypes.number.isRequired,
  amount: PropTypes.number.isRequired,
  venmoAccount: PropTypes.string.isRequired,
  showPayout: PropTypes.bool,
};

ListItem.defaultProps = {
  showPayout: false,
};

function ListItemWrapper(props) {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        // eslint-disable-next-line react/destructuring-assignment, react/prop-types
        const data = await getUserDataOnce(props.uid);
        setUserData(data);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }
    fetchData();
    // eslint-disable-next-line react/destructuring-assignment, react/prop-types
  }, [props.uid]);

  return <ListItem {...props} venmoAccount={userData?.venmoAccount} />;
}

// playerId === phone ?
function UserSettlementSummary({
  eventId,
  playerId,
  onGoBack,
  teamsPlay,
  totalStake,
}) {
  const teeTimes = useTeeTimes(eventId);

  const [isOpen, setIsOpen] = useState(false);
  const { user } = useAuth();
  const userData = useUserData(user);

  const { phone, venmoAccount } = userData ?? {
    phone: null,
    venmoAccount: null,
  };

  // eslint-disable-next-line no-unused-vars
  const {
    displayName,
    receive,
    send,
    net,
    phone: playerPhone,
  } = teamsPlay
    ? teeTimes
        .map((team) =>
          team.teams.map((teamInTeamsArray) => teamInTeamsArray.users),
        )
        .flat(2)
        .find((player) => player.phone === playerId) ?? {}
    : teeTimes
        ?.map(({ users }) => users)
        ?.flat()
        ?.find((player) => player.phone === playerId) ?? {};

  return (
    <div className="tee-time-player-payout-root">
      {teeTimes?.length ? (
        <div>
          <div className="tee-time-player-payout--head-wrapper">
            <div
              className="left tee-time-player-payout--back"
              onClick={() => onGoBack()}
              type="Button"
              aria-hidden="true"
            >
              <img src={ArrowLeft} alt="back-icon" style={{ marginRight: 5 }} />
              Back
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="tee-time-player-payout--user-name">
                {nameInitials(displayName)}
              </div>
              <div className="tee-time-player-payout--breakdown">
                Settlement Breakdown
              </div>
            </div>
            <div style={{ marginRight: 8 }}>
              {!venmoAccount && playerId === phone && (
                <VenmoButton plus openModal={() => setIsOpen(!isOpen)} />
              )}
            </div>
          </div>
          <div className="tee-time-player-payout--list-root">
            <div className="tee-time-player-payout--list-title">Collect</div>
            {receive?.length ? (
              receive.map((p) => (
                <ListItemWrapper
                  key={p.uid}
                  displayName={p.displayName}
                  courseHandicap={p.courseHandicap}
                  amount={p.amount}
                  uid={p.uid}
                />
              ))
            ) : (
              <div className="tee-time-player-payout--list-empty">
                DID NOT WIN ANYTHING
              </div>
            )}
            <div className="tee-time-player-payout--list-title">Pay</div>
            {send?.length ? (
              send
                .map((p) => ({ ...p, amount: -p.amount }))
                .map((p) => (
                  <ListItemWrapper
                    key={p.uid}
                    displayName={p.displayName}
                    courseHandicap={p.courseHandicap}
                    amount={p.amount}
                    uid={p.uid}
                    showPayout={user?.phone === playerId}
                  />
                ))
            ) : (
              <div className="tee-time-player-payout--list-empty">
                DID NOT LOSE ANYTHING
              </div>
            )}
            <div className="tee-time-player-payout--total-wrapper">
              <div className="tee-time-player-payout--total-label">
                <div>Total</div>
                <div style={{ marginLeft: 10 }}>
                  <PayoutValue amount={net} />
                </div>
              </div>
            </div>
          </div>
          <Sheet
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            detent="full-height"
          >
            <Sheet.Container style={{ backgroundColor: "#EDEFEF" }}>
              <Sheet.Header />
              <VenmoForm setOpen={() => setIsOpen(false)} />
            </Sheet.Container>

            <Sheet.Backdrop />
          </Sheet>
          {net >= 0 && playerPhone === phone && <Tip totalStake={totalStake} />}
        </div>
      ) : (
        <ActivityIndicator />
      )}
    </div>
  );
}

UserSettlementSummary.propTypes = {
  eventId: PropTypes.string,
  playerId: PropTypes.string,
  onGoBack: PropTypes.func,
  teamsPlay: PropTypes.bool,
  totalStake: PropTypes.number,
};

UserSettlementSummary.defaultProps = {
  eventId: null,
  playerId: null,
  teamsPlay: false,
  onGoBack: null,
  totalStake: 0,
};

export { UserSettlementSummary };
